export default function isDemoVersion() {
  return window.location.href.match(/\/\?demo\/#/);
}